import en from "./en.json";

const translations = { en };

export default translations;
